import React, { Component } from "react";
import { Link } from "react-router-dom";
class Footer extends Component {
  render() {
    return (
      <footer id="footer" className="clearfix">
        <div id="footer-widgets" className="container">
          <div className="themesflat-row gutter-30">
            <div className="col span_1_of_3">
              <div className="widget widget_text">
                <div className="textwidget">
                  <p>
                    <img
                      src="../assets/img/logo-white-cityx@2x.png"
                      alt="imagealt"
                      width={170}
                      height={34}
                    />
                  </p>
                  <p
                    className="margin-bottom-15"
                    style={{ color: "white", fontSize: "10px" }}
                  >
                    CREATED WITH ❤︎ IN CROATIA.
                  </p>
                  <ul>
                    <li>
                      <div className="inner">
                        <span className="fa fa-map-marker" />
                        <span className="text">
                          Samobor, <span className="sl">Croatia</span> / Gent,{" "}
                          <span className="sl">Belgium</span>
                        </span>
                      </div>
                    </li>
                    {/* <li>
                      <div className="inner">
                        <span className="fa fa-phone" />
                        <span className="text">
                          KONTAKT : (+385) 1 1234 567
                        </span>
                      </div>
                    </li> */}
                    <li className="margin-top-7">
                      <div className="inner">
                        <span className=" font-size-14 fa fa-envelope" />
                        <span className="text">info@cityx.hr</span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              {/* /.widget_text */}
              <div
                className="themesflat-spacer clearfix"
                data-desktop={0}
                data-mobile={0}
                data-smobile={35}
              />
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
